// Brand assets and curated imagery for Schonell Projects
export const LOGO = "https://customer-assets.emergentagent.com/job_0ba12a94-5fda-43ed-9696-1ab674e47024/artifacts/7ee1ne9n_IMG_4276.PNG";
export const FOUNDER = "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/i85z4ror_IMG_4182.PNG";
export const EXTERIOR = "https://customer-assets.emergentagent.com/job_0ba12a94-5fda-43ed-9696-1ab674e47024/artifacts/dug3bamh_IMG_4076%20%281%29.jpg";

export const HOME_FEATURE = "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/n6p6tz37_IMG_4081%20%281%29.jpg";

// Parriwi Project — Mosman, NSW (full renovation)
export const PARRIWI_GALLERY = [
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/cs59hak1_IMG_4060%20%282%29.jpg", caption: "Kitchen", note: "Bespoke marble island & oak joinery" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/jl3f8ymr_IMG_4063%20%281%29.jpg", caption: "Kitchen & Dining", note: "Open-plan entertaining" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/4rqty6jh_IMG_4081%20%281%29.jpg", caption: "Living", note: "Oak joinery & travertine fireplace" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/53jv9pwk_IMG_4059%20%281%29.jpg", caption: "Living & Outlook", note: "Indoor-outdoor living with district views" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/rcjecz2j_IMG_4064%20%281%29.jpg", caption: "Media Room", note: "Oak shelving & floating marble bench" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/0ocohyg7_IMG_4065%20%281%29.jpg", caption: "Master Suite", note: "Wrap-around glazing & water views" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/04vdbxu7_IMG_4067%20%281%29.jpg", caption: "Master Ensuite", note: "Double marble vanity & freestanding bath" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/bk2b9xxn_IMG_4074%20%281%29.jpg", caption: "Entry", note: "Sandstone feature wall" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/h7mccltx_IMG_4066%20%281%29.jpg", caption: "Dressing Room", note: "Custom oak cabinetry & marble detailing" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/4te0rbcf_IMG_4071.jpg", caption: "Powder Room", note: "Statement marble vanity" },
  { src: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/0gaz30bo_IMG_4072.jpg", caption: "Ensuite", note: "Natural stone & warm timber" },
];

// Mosman Apartment — Mosman, NSW (cosmetic renovation, before & after)
export const MOSMAN = [
  {
    name: "Kitchen",
    note: "Charcoal joinery, stone benchtops & black tapware",
    after: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/p9850vz2_image2.jpg",
    before: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/0h1bb9dv_image6%20%281%29.jpg",
  },
  {
    name: "Bathroom",
    note: "Floating vanity, frameless mirror & marble detailing",
    after: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/txhcyqco_image6.jpg",
    before: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/7a0f3jbn_image9.jpg",
  },
  {
    name: "Bedroom",
    note: "Soft neutral palette, layered textures & warm styling",
    after: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/sprnyqwm_image5.jpg",
    before: "https://customer-assets.emergentagent.com/job_renovation-refined/artifacts/79hpzr0z_image7.jpg",
  },
];

export const MARBLE = "https://static.prod-images.emergentagent.com/jobs/0ba12a94-5fda-43ed-9696-1ab674e47024/images/128d27237ef8b199b25f2f8e05d70591d5a536342dd2154918dd89244aa31ca4.png";
export const OAK = "https://static.prod-images.emergentagent.com/jobs/0ba12a94-5fda-43ed-9696-1ab674e47024/images/92812295e87a7a554332062dc1088a628c35e22247289296b73388fcd5d0da6b.png";
export const STONE_LINEN = "https://static.prod-images.emergentagent.com/jobs/0ba12a94-5fda-43ed-9696-1ab674e47024/images/bbff69027041918a36c6e3b9969fd4d575519ba10d217cb202e735bdda78d698.png";

export const CONTACT = {
  phone: "0423 421 129",
  phoneRaw: "0423421129",
  email: "paigeschonell@gmail.com",
  instagram: "@schonellprojects",
  instagramUrl: "https://www.instagram.com/schonellprojects",
  location: "Sydney · Lower North Shore",
};
